import { IReduxState } from 'types/redux';

export const runwaysStateSelector = (state: IReduxState) => state.veta.runways;

export const runwaysStatusesSelector = (state: IReduxState) => state.veta.runways.statuses;
